import React, { useEffect, useState } from "react";
import axios from "axios";
import "../ui/common.css";
import AOS from "aos";
import { useNavigate } from "react-router-dom";
import "aos/dist/aos.css";

import aboutImg from "../Asstes/Images/about-img-1.png";
import aboutImg2 from "../Asstes/Images/about-img-2.png";

import Slider from "react-slick";
import aboutBlog1 from "../Asstes/Images/about-blog-1.png";
import aboutBlog2 from "../Asstes/Images/about-blog-ii.png";
import aboutBlog3 from "../Asstes/Images/about-blog-3.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import config from "../config";

const AboutSection = () => {
  const navigate = useNavigate();
  const [bannerData, setBannerData] = useState(null);
  const [contentData, setContentData] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [insights, setInsights] = useState([]);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    // Fetch banner data
    axios
      .get(`${config.API_BASE_URL}/banners/about-us`)
      .then((res) => {
        if (res.data?.banners?.length > 0) {
          setBannerData(res.data.banners[0]);
        }
      })
      .catch((err) => {
        console.error("Error fetching banner data:", err);
      });

    // Fetch about-us content data
    axios
      .get(`${config.API_BASE_URL}/content/about-us`)
      .then((res) => {
        if (res.data?.content?.length > 0) {
          const sorted = res.data.content.sort(
            (a, b) => Number(a.content_order) - Number(b.content_order)
          );
          setContentData(sorted);
        }
      })
      .catch((err) => {
        console.error("Error fetching content data:", err);
      });

    // Fetch company reviews dynamically
    axios
      .get(`${config.API_BASE_URL}/content/reviews`)
      .then((res) => {
        if (res.data?.content?.length > 0) {
          const formattedReviews = res.data.content.map((review) => ({
            id: review.id,
            title: review.content_title, // Reviewer Name & Designation
            text: review.content_text, // The review paragraph
            image: review.content_image, // Reviewer Image/Logo
          }));
          setReviews(formattedReviews);
        }
      })
      .catch((err) => {
        console.error("Error fetching reviews data:", err);
      });

    // Fetch Insights dynamically
    axios
      .get(`${config.API_BASE_URL}/images/about-us`)
      .then((res) => {
        if (res.data?.images?.length > 0) {
          const formattedInsights = res.data.images.map((item) => ({
            img: `/prosapiens-cms/public/${item.image_name}`,
            text: item.content_text
              ? item.content_text.replace(/<\/?[^>]+(>|$)/g, "") // remove HTML tags
              : "",
          }));
          setInsights(formattedInsights);
        }
      })
      .catch((err) => {
        console.error("Error fetching insights data:", err);
      });
  }, []);

  // Helper to split multiple reviews inside one content_text HTML string
  function splitReviewsFromContentText(htmlString) {
    if (!htmlString) return [];

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, "text/html");

    const reviews = [];
    const h2Elements = doc.querySelectorAll("h2");

    h2Elements.forEach((h2) => {
      const imgP = h2.previousElementSibling;
      const reviewP = h2.nextElementSibling;

      if (imgP && reviewP) {
        const chunkHTML = imgP.outerHTML + h2.outerHTML + reviewP.outerHTML;
        reviews.push(chunkHTML);
      }
    });

    return reviews;
  }

  const sliderSettings = {
    dots: false, // remove dots
    arrows: false,
    infinite: true,
    speed: 600,
    autoplay: true, // enable auto sliding

    autoplaySpeed: 3000, // 3 seconds per slide, adjust as needed
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  const handleClientClick = () => {
    window.location.href = "hire-on-prosapiens";
  };

  // Render dynamic sections with alternating image/text
  const renderDynamicSections = () => {
    const sections = contentData.filter((c) =>
      [3, 4, 5].includes(Number(c.content_order))
    );

    return sections.map((section, index) => {
      const isImageLeft = index % 2 === 0;
      return (
        <div className="image-container" key={section.id}>
          {isImageLeft && (
            <div className="image-side" data-aos="fade-right">
              {section.content_image ? (
                <img
                  src={`/prosapiens-cms/public/${section.content_image}`}
                  alt={section.content_title}
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                    backgroundColor: "#eee",
                  }}
                />
              )}
            </div>
          )}
          <div
            className="text-side"
            data-aos="fade-left"
            dangerouslySetInnerHTML={{ __html: section.content_text }}
          />
          {!isImageLeft && (
            <div className="image-side" data-aos="fade-right">
              {section.content_image ? (
                <img
                  src={`/prosapiens-cms/public/${section.content_image}`}
                  alt={section.content_title}
                />
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                    backgroundColor: "#eee",
                  }}
                />
              )}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <div>
      {/* Banner Section */}
      <section
        className="about-bg about-mobile"
        data-aos="zoom-in"
        style={{
          backgroundImage: bannerData
            ? `url(/prosapiens-cms/public/${bannerData.banner_image})`
            : "none",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="overlay container">
          <div className="hero-text" data-aos="fade-up">
            <h1 data-aos="fade-up" data-aos-delay="100">
              {bannerData ? bannerData.banner_title : "Loading..."}
            </h1>
            <p
              style={{ color: "#fff" }}
              data-aos="fade-up"
              data-aos-delay="200"
              dangerouslySetInnerHTML={{
                __html: bannerData ? bannerData.content_text : "",
              }}
            />
          </div>
        </div>
      </section>

      {/* 2-section (Dynamic first content) */}
      {contentData[0] && (
        <section className="what-we-do">
          <div className="container">
            <div className="image-container">
              <div className="image-side">
                <img
                  src={
                    contentData[0].content_image
                      ? `/prosapiens-cms/public/${contentData[0].content_image}`
                      : aboutImg
                  }
                  alt="Office meeting"
                />
              </div>
              <div
                className="text-side"
                dangerouslySetInnerHTML={{
                  __html: contentData[0].content_text,
                }}
              />
            </div>
          </div>
        </section>
      )}

      {/* 3rd-section (Dynamic second content) */}
      {contentData[1] && (
        <section className="">
          <div className="container">
            <div
              className="image-container"
              style={{ flexDirection: "row-reverse" }}
            >
              <div className="image-side-about" data-aos="fade-left">
                <img
                  src={
                    contentData[1].content_image
                      ? `/prosapiens-cms/public/${contentData[1].content_image}`
                      : aboutImg2
                  }
                  alt="Office meeting"
                />
              </div>
              <div
                className="text-side about"
                data-aos="fade-right"
                dangerouslySetInnerHTML={{
                  __html: contentData[1].content_text,
                }}
              />
            </div>
          </div>
        </section>
      )}

      {/* 4th-section */}
      <div className="about-pg about-pg-mobile">
        <div className="container">
          <div className="proSapiens-advantage">
            <h1>Organizational Structure &amp; Design</h1>
          </div>

          {renderDynamicSections()}
        </div>
      </div>

      {/* 5-section Insights */}
      <section className="about-slider">
        <div className="container">
          <h1>Explore our insights</h1>
          <div className="owl-carousel owl-theme">
            <Slider {...sliderSettings}>
              {insights.map((item, index) => (
                <article className="article-card" key={index}>
                  <div className="card-content">
                    <div className="card-image">
                      <img src={item.img} alt="AI Hiring Technology" />
                    </div>
                    <p className="article-excerpt-p">{item.text}</p>
                  </div>
                </article>
              ))}
            </Slider>
          </div>
        </div>
      </section>

      {/* 6 section: Reviews with dynamic fetched data */}
      <section className="slider-revievs">
        <div className="container">
          <div className="slider-box">
            <div className="reviews-text">
              <h1>Reviews</h1>
              <a href="company-reviews" className="cta-reviews">
                See All Reviews →
              </a>
            </div>
            <h2>
              Discover how top professionals have transformed their careers with
              our AI-driven hiring process.
            </h2>

            <div className="owl-carousel owl-theme">
              {/* <Slider {...sliderSettings}>
                {reviews.length > 0 ? (
                  reviews.map((review, index) => (
                    <div className="item" key={index}>
                      <div
                        className="review-content"
                        dangerouslySetInnerHTML={{
                          __html: review.content_text,
                        }}
                      />
                    </div>
                  ))
                ) : (
                  <p>Loading reviews...</p>
                )}
              </Slider> */}

              <Slider {...sliderSettings}>
                {reviews.length > 0 ? (
                  reviews.map((review, index) => (
                    <div className="item" key={index}>
                      <div className="review-card">
                        <div className="review-top">
                          {review.image && (
                            <img
                              src={`/prosapiens/prosapiens-cms/public/${review.image}`}
                              alt={review.title}
                              className="review-img"
                            />
                          )}
                          <h3 className="review-title">{review.title}</h3>
                        </div>
                        <div
                          className="review-text"
                          dangerouslySetInnerHTML={{ __html: review.text }}
                        />
                      </div>
                    </div>
                  ))
                ) : (
                  <p>Loading reviews...</p>
                )}
              </Slider>
            </div>
          </div>
        </div>
      </section>

      {/* Last Call to Actions */}
      {(() => {
        const jobBoxContent = contentData.find(
          (item) => item.slug_name === "about-us" && item.content_order === "6"
        );

        if (!jobBoxContent) return <p>Loading content...</p>;

        // Parse content_text and get inner HTML of .job-box (h1 + p)
        const parser = new DOMParser();
        const doc = parser.parseFromString(
          jobBoxContent.content_text,
          "text/html"
        );
        const jobBoxDiv = doc.querySelector(".job-box");
        const innerHTML = jobBoxDiv ? jobBoxDiv.innerHTML : "";

        return (
          <div className="container">
            <div className="job-box">
              <div dangerouslySetInnerHTML={{ __html: innerHTML }} />
              <button
                className="cta-button"
                onClick={() => navigate("/openings")}
              >
                GET HIRED WITH PROSAPIENS →
              </button>
              <button className="cta-button" onClick={handleClientClick}>
                HIRE WITH PROSAPIENS →
              </button>
            </div>
          </div>
        );
      })()}
    </div>
  );
};

export default AboutSection;
